export type GlobalSize = 'sm' | 'md' | 'lg';

export const GLOBAL_HEIGHT: Record<GlobalSize, string> = {
  sm: 'h-8',
  md: 'h-10',
  lg: 'h-12'
};
